import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'

export const EnterprisePageTemplate = ({ title, content, contentComponent }) => {
  const PageContent = contentComponent || Content

  useEffect(() => window.ScrollReveal().reveal('.reveal'));

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const onFormSubmit = (event) => {
    event.preventDefault();

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer 3e01d576-5c53-4bca-841b-add7715591f4");

    var raw = JSON.stringify({"subject":"Plainpad Communication - " + name,"content":message,"email":email});

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://api.alextselegidis.com/index.php/messaging/v1/messages", requestOptions)
      .then(response => response.text())
      .then(result => {
        alert('Thanks for getting in touch, we will get back to you as soon as possible.');
        setName('');
        setEmail('');
        setMessage('');
        console.log(result)
      })
      .catch(error => console.log('error', error));
  };

  return (
    <section className="section section--gradient">
      <div className="container">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="section">
              <h2 className="title is-size-3 has-text-weight-bold is-bold-light">
                {title}
              </h2>
              <PageContent className="content" content={content} />

              <form id="enterprise-form" onSubmit={onFormSubmit}>
                <div className="field">
                  <label className="label">Name</label>
                  <input className="input" type="text" value={name} onChange={(event) => setName(event.target.value)}/>
                </div>

                <div className="field">
                  <label className="label">Email</label>
                  <input className="input" type="text" value={email} onChange={(event) => setEmail(event.target.value)}/>
                </div>

                <div className="field">
                  <label className="label">Message</label>
                  <textarea className="textarea" rows="10" value={message} onChange={(event) => setMessage(event.target.value)}/>
                </div>

                <div className="field">
                  <div className="control">
                    <button className="btn" style={{minWidth: '150px' }}>Send</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

EnterprisePageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
}

const EnterprisePage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <EnterprisePageTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
      />
    </Layout>
  )
}

EnterprisePage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default EnterprisePage

export const enterprisePageQuery = graphql`
  query EnterprisePage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`
